// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { DetectionZoneOccupancy, IDetectionZoneOccupancy } from "./DetectionZoneOccupancy.gen";

export interface IFacilityOccupancy {
	facilityId: string | undefined;

	dateCreated: string | undefined;

	zoneOccupancy: IDetectionZoneOccupancy[] | undefined;

	$type?: string | undefined;
}
export class FacilityOccupancy {
	constructor(data?: IFacilityOccupancy) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
		this.zoneOccupancy = data.zoneOccupancy ? data.zoneOccupancy.map((z: any) => new DetectionZoneOccupancy(z)) : [];
	}

	facilityId: string | undefined;

	dateCreated: Date | undefined = new Date();

	zoneOccupancy: DetectionZoneOccupancy[] | undefined = [];

	static $type: string = "CoreApi.Models.FacilityOccupancy, ";
	$type?: string | undefined = FacilityOccupancy.$type;
}

